import React, { useState, useEffect } from 'react';
import { updatedata, getdata } from "../../util/global";


const defaultformdata = {
  spreadsheetid: '',
  sheetname: 'Sheet1',
  connected: false
};

const GoogleDocsConfigForm = ({ showmodal, setshowmodal, phonenumber }) => {
  const [formdata, setformdata] = useState(defaultformdata);
  const [googleconfig, setgoogleconfig] = useState({});

  const fetchdata = async () => {
    if (!phonenumber?._id) return;
    try {
      const gdata = await getdata({ filter: { datatype: "googledocconfigdata", _phonenumberid: phonenumber._id } });
      if (gdata && gdata.length > 0) {
        setgoogleconfig(gdata[0]);
      } else {
        setgoogleconfig({ ...defaultformdata });
      }
      console.log("google fetchdata called");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (showmodal === "showgoogleconfig") {
      setformdata({ ...defaultformdata });
      setgoogleconfig({});
      fetchdata();
    }
  }, [showmodal, phonenumber?._id]);

  useEffect(() => {
    if (googleconfig && Object.keys(googleconfig).length > 0) {
      setformdata({ ...defaultformdata, ...googleconfig });
    }
  }, [googleconfig]);

  useEffect(() => {
    const handleauthmessage = (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.type === 'googleauthsuccess') {
        fetchdata();
      } else if (event.data?.type === 'googleautherror') {
        alert('authentication failed: ' + (event.data.error || 'unknown error'));
      }
    };

    window.addEventListener('message', handleauthmessage);
    return () => window.removeEventListener('message', handleauthmessage);
  }, [phonenumber?._id]);

  const connectgoogleoauth = async () => {
    try {
      const res = await fetch(`/googleauthurl?phonenumberid=${phonenumber._id}`, {
        headers: { 'Authorization': `Bearer ${APPUSER.user.token}` }
      });
      const data = await res.json();
      if (data.url) {
        const w = 500;
        const h = 600;
        const left = window.screen.width / 2 - w / 2;
        const top = window.screen.height / 2 - h / 2;
        window.open(
          data.url,
          'Connect Google Sheets',
          `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=no, width=${w}, height=${h}, top=${top}, left=${left}`
        );
      }
    } catch (err) {
      console.error("error opening google oauth popup:", err);
    }
  };

  const updategoogledocsconfig = async (gconfig) => {
    let sid = gconfig.spreadsheetid || '';
    const match = sid.match(/\/spreadsheets\/d\/([a-zA-Z0-9-]+)/);
    if (match) {
      sid = match[1];
    }

    gconfig.spreadsheetid = sid;
    gconfig.phonenumberid = phonenumber._id;
    gconfig.datatype = "googledocconfigdata";
    await updatedata({ data: gconfig });
    fetchdata();
  };

  if (showmodal !== "showgoogleconfig") return null;

  const saveconfig = async () => {
    $("#waitinggif").show();
    await updategoogledocsconfig(formdata);
    $("#waitinggif").hide();
    setshowmodal("");
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Google Sheets Configuration</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group" style={{ textAlign: 'center', marginBottom: '15px' }}>
            {formdata.connected ? (
              <span style={{ color: '#2e7d32', fontWeight: 'bold' }}>
                ✓ Google Account Connected
              </span>
            ) : (
              <button 
                type="button" 
                className="btn-blue" 
                style={{ width: '100%', backgroundColor: '#4285F4' }}
                onClick={connectgoogleoauth}
              >
                Sign in with Google
              </button>
            )}
          </div>

          <div className="form-group">
            <label>Google Sheet URL or Spreadsheet ID</label>
            <input 
              type="text" 
              className="form-input" 
              placeholder="https://docs.google.com/spreadsheets/d/.../edit"
              value={formdata.spreadsheetid || ''} 
              onChange={(e) => setformdata({ ...formdata, spreadsheetid: e.target.value })} 
            />              
          </div>

          <div className="form-group">
            <label>Sheet / Tab Name</label>
            <input 
              type="text" 
              className="form-input" 
              value={formdata.sheetname || ''} 
              onChange={(e) => setformdata({ ...formdata, sheetname: e.target.value })} 
            />              
          </div>

          <button className="btn-blue full-width" onClick={saveconfig}>
            Save <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{ display: 'none', width: '25px', position: 'absolute' }} alt="saving" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoogleDocsConfigForm;